export const imageUtils = {
  putTimeStamp(url: string | undefined | null): string {
    const timestamp = Date.now();
    if (!url) return "";

    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}t=${timestamp}`;
  },
};
